import { Link } from "react-router-dom";
import React from "react";

export default function MentorsityLinks() {
  return (
    <div className="flex flex-col items-start space-y-1">
      <span className="text-xl sm:text-2xl font-semibold mb-2">MENTORSITY</span>
      <Link to="/about-us" className="footer-links hover:underline text-sm sm:text-base">
        About Us
      </Link>
      <Link to="/careers" className="footer-links hover:underline text-sm sm:text-base">
        Careers
      </Link>
      <Link to="/placement-support" className="footer-links hover:underline text-sm sm:text-base">
        Placement Support
      </Link>
      <Link to="/blogs" className="footer-links hover:underline text-sm sm:text-base">
        Mentorsity Blog
      </Link>
      <Link to="/resources" className="footer-links hover:underline text-sm sm:text-base">
        Resources
      </Link>
      <Link to="/free-courses" className="footer-links hover:underline text-sm sm:text-base">
        Mentorsity Free Courses
      </Link>
    </div>
  );
}
